// extracted by mini-css-extract-plugin
export default {"skeleton":"PYGbCC","container":"tNXV0n","isLink":"UXibop","is-color-grey":"HXIYxx","is-color-dark-grey":"TdPBBx","is-color-teal":"_SedGx"};